import { render, staticRenderFns } from "./UserFavorites.vue?vue&type=template&id=a6ab6628&scoped=true&"
import script from "./UserFavorites.vue?vue&type=script&lang=js&"
export * from "./UserFavorites.vue?vue&type=script&lang=js&"
import style0 from "./UserFavorites.vue?vue&type=style&index=0&id=a6ab6628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ab6628",
  null
  
)

export default component.exports